/* 馬超傳・第 3、4 章：渭南（211 年）
 * 渭水沿北邊流；南邊是平原。關西聯軍的營在西邊，曹營在東邊，兩軍中間是會語的地方。西邊的路通往安定、涼州。 */
export const XICAMP = [2000, 2500], CAOCAMP = [6700, 2500], TALK = [4300, 2500], EXIT = [300, 2600];
export default {
  id: 'machao_weinan', name: '渭南', W: 8000, H: 4800, seed: 2112,
  bases: [XICAMP, CAOCAMP],
  rivers: [{ pts: [[-100, 500], [2600, 560], [5400, 480], [8100, 540]], hw: 260, fords: [] }],
  roads: [{ pts: [EXIT, XICAMP, TALK, CAOCAMP, [7800, 2500]], w: 150 }],
  rocks: [[3200, 1300, 420, 190], [5400, 1300, 420, 190], [3200, 3800, 420, 190], [5400, 3800, 420, 190], [1000, 3900, 360, 170], [1000, 1300, 360, 170]],
  woods: 0.25,
  sight: 0.85,
  clearings: [[XICAMP[0], XICAMP[1], 700], [TALK[0], TALK[1], 900], [CAOCAMP[0], CAOCAMP[1], 650], [EXIT[0] + 200, EXIT[1], 300]],
  tents: [{ x: XICAMP[0], y: XICAMP[1], n: 10, r: 520, chief: true, col: '#5a6a3a', flag: '馬' }, { x: CAOCAMP[0], y: CAOCAMP[1], n: 8, r: 460, chief: true, col: '#3b5a99', flag: '曹' }],
};
